import {Button} from 'primereact/button'
import {useState} from 'react'

import {trlObject} from '~/services/intl'

const key = 'privacyPolicy'

export default function PrivacyPolicyMessage() {
    const [accepted, setAccepted] = useState(localStorage.getItem(key) !== null)
    const messages = trlObject('_privacy-policy')

    return !accepted && <div className='message'>
        <span className='message__text'>
            {messages.prefix}
            <a
                className='link'
                href='/static/privacy-policy.pdf'
                target='_blank'
            >
                {messages.link}
            </a>
            {messages.suffix}
        </span>
        <Button
            type='button'
            className='landing__button landing-blue-button message__button'
            onClick={() => {
                setAccepted(true)
                localStorage.setItem(key, '')
            }}
        >
            {messages.accept}
        </Button>
    </div>
}
